export enum InsightPopupTabs {
    DETAILS = 'details',
    FEEDBACK = 'feedback',
    QUESTIONS = 'frageuebersicht',
    LEARNING_HISTORY = 'lernfortschritt',
    SKILLS_PROFILE = 'kompetenzprofil',
    TOPICS = 'themen'
}
